const styles = ({ shape, palette, spacing }, props) => ({
  rootContainer: {
    borderRadius: shape.borderRadius * 2,
    border: props?.account?.isClosed ? `1px solid ${palette.border.light}` : `1px solid ${palette.border.light}`,
    backgroundColor: palette.background.default,
    margin: `${spacing(1)} 0px`,
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
  },
  threeDotButton: {
    marginLeft: 'auto',
  },
  accountTypeSelector: {
    padding: 20,
    paddingRight: 30,
    color: palette.text.primary,
    width: '100%',
    '&:focus': {
      outline: 'none',
    },
  },
  listItemText: {
    paddingLeft: 0,
  },
  dialogContent: {
    minWidth: 500,
    display: 'flex',
  },
  primaryItem: {
    display: 'flex',
    alignItems: 'center',
  },
  statusContainer: {
    borderRadius: shape.borderRadius,
    flex: '0 0 auto',
    margin: 'auto 5px',
    height: 'inherit',
  },
  statusRoot: {
    borderRadius: shape.borderRadius,
    marginTop: 1,
    boxSizing: 'border-box',
    padding: `${spacing(0.25)} ${spacing(1)}`,
    color: palette.text.primary,
  },
  statusClose: {
    backgroundColor: palette.inactive.light,
  },
  statusError: {
    backgroundColor: palette.warning.light,
  },
  txnsTransfersStatusContainer: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  greenCheck: {
    color: palette.success.dark,
  },
  rightRowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  spinner: {
    marginRight: 5,
    //  marginTop: 15,
    cursor: 'pointer',
  },
  highlightedItem: {
    display: 'flex',
    alignItems: 'center',
    color: palette.primary.main,
  },
  hiddenIcon: {
    marginRight: 16,
    color: palette.icon.main,
    minWidth: '24px !important',
    opacity: 0,
  },
  highlightedIcon: {
    marginRight: 16,
    minWidth: '24px !important',
    color: palette.primary.main,
  },
  menuItem: {
    display: 'flex',
    color: palette.text.primary,
    alignItems: 'center',
  },
  text: {
    color: palette.text.primary,
  },
  highlightText: {
    color: palette.primary.main,
  },
  icon: {
    marginLeft: 5,
  },
  imgClass: {
    marginLeft: 12,
    height: 24,
    width: 24,
  },
  textSpacing: {
    marginTop: 24,
  },
});

export default styles;
